import { Link } from 'react-router-dom'
import errorImage from '../../assets/images/404.png'
import zaloIcon from '../../assets/icons/Icon_of_Zalo.png'
import facebookIcon from '../../assets/icons/Facebook_Logo_.png'
import './NotFound.css'

const NotFound = () => {
  return (
    <div className="not-found-page" id="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <div className="not-found-visual">
            <img src={errorImage} alt="Lỗi 404 Không tìm thấy trang - MAXCONST" className="not-found-img" />
          </div>
          
          <div className="not-found-text-section">
            <span className="not-found-badge">LỖI 404</span>
            <h1 className="not-found-title">Oops! Không tìm thấy trang</h1>
            <p className="not-found-message">
              Xin lỗi, chúng tôi không tìm thấy trang mà bạn đang yêu cầu! Có thể liên kết đã bị thay đổi, bị xóa, hoặc bạn đã gõ nhầm địa chỉ URL.
            </p>
            
            <div className="not-found-info">
              <p>Nếu bạn cần hỗ trợ thêm, vui lòng liên hệ:</p>
              <ul>
                <li>
                  <i className="fas fa-phone-alt" /> <strong>Hotline:</strong> <a href="tel:0979808278">0979 808 278</a>
                </li>
                <li>
                  <i className="fas fa-envelope" /> <strong>Email:</strong> <a href="mailto:vpmaxconst@gmail.com">vpmaxconst@gmail.com</a>
                </li>
                <li>
                  <img src={zaloIcon} alt="Zalo" className="not-found-contact-icon" />
                  <strong>Zalo:</strong> <a href="https://zalo.me/0979808278" target="_blank" rel="noopener noreferrer">0979 808 278</a>
                </li>
                <li>
                  <img src={facebookIcon} alt="Facebook" className="not-found-contact-icon" />
                  <strong>Facebook:</strong> <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">MAXCONST</a>
                </li>
              </ul>
            </div>
            
            <Link to="/" className="btn btn-primary not-found-btn" id="not-found-back-home">
              <i className="fas fa-home" /> Quay về Trang chủ
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
